<template>
    <div class="help__row">
        <div class="help__icon">
            <component :is="props.itemData.iconComponent" />
        </div>
        <div class="help__content">
            <h5 class="help__title">{{ props.itemData.title }}</h5>
            <h6 class="help__description">{{ props.itemData.description }}</h6>
            <p class="help__description">
                <span>{{ props.itemData.visit }}:</span> 
                <span class="help__link" :class="helpClasses">
                    {{ props.itemData.link }}
                </span>
            </p>
        </div>
        <div class="help__qr" :class="helpQrClasses">
            <qrcode-vue v-if="props.itemData.url" class="qr-code-small qr-content__img" :value="props.itemData.url" :level="'H'" render-as="svg" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import type { IHelpItem } from '../types/help';
    import QrcodeVue from 'qrcode.vue';
    import { computed, type ComputedRef } from 'vue';

    const props = defineProps<{
        itemData: IHelpItem;
    }>()

    const helpClasses: ComputedRef<{[key: string]: boolean}> = computed(() => {
        return {
            'help__link_skeleton': !(props.itemData.link)
        }
    });
    const helpQrClasses: ComputedRef<{[key: string]: boolean}> = computed(() => {
        return {
            'help__qr_skeleton': !(props.itemData.link)
        }
    });
</script>
